import * as React from 'react'
import Popup from 'reactjs-popup'
import { CurrentUserType } from '../../CommonContext'
import ScanForm from '../../scan_app/ScanForm'
import { areaToOption } from '../../scan_app/ScanFormFields'
import { useState } from 'react'
import TimeRegistrationForm from './TimeRegistrationForm'
import { JobNumberShape, MachineShape, ResourcesRecordShape } from '../../../api/api_data_types'
import useScanForm from '../../../hooks/useScanForm'
import useResourcesRecordFormController from '../../../hooks/useResourcesRecordFormController'
import SearchFiles from '../../files/SearchFiles'

type ScanPopupButtonProps = {
  buttonClass: string
  buttonTitle: string
  availableAreas: string[]
  availableMachines: { id: number; name: string }[]
  currentUser: CurrentUserType
  orderNumber?: string
  orderId?: string
  initialArea?: string
  jobnumber: JobNumberShape
  onSuccessfulScan?: () => void
}

export default function ScanPopupButton(props: ScanPopupButtonProps) {
  const {
    buttonClass,
    buttonTitle,
    jobnumber,
    orderNumber,
    orderId,
    initialArea,
    currentUser,
    availableAreas,
    availableMachines,
    onSuccessfulScan,
  } = props

  const area = currentUser.areas.includes(initialArea) ? initialArea : currentUser.areas[0] || availableAreas[0]
  const { username, default_machines } = currentUser
  const orderAndId = orderId ? `${orderNumber}-${orderId}` : orderNumber
  const [currentTab, setCurrentTab] = useState<'scan' | 'time_form' | 'orders_cases'>('scan')
  const [scanCompeted, setScanCompeted] = useState(false)

  const scanFormInitialValues = {
    area: areaToOption(area),
    order_and_id: orderAndId,
    operator: username,
    machine: default_machines?.[0]?.no,
    order_note: '',
  }
  const form = useScanForm(scanFormInitialValues)
  const selectedMachineId = form.watch('machine')
  let machineFields = []
  if (selectedMachineId) {
    const selectedMachine = availableMachines.find(machine => machine.id.toString() === selectedMachineId)
    if (selectedMachine) {
      machineFields = [
        {
          id: null,
          machine: selectedMachine,
          machine_id: selectedMachineId,
          time: 0,
        },
      ]
    }
  }
  const record: ResourcesRecordShape = {
    id: null,
    date: new Date().toISOString().split('T')[0],
    times: [],
    is_completed: false,
    is_master: true,
    items: [],
    machines: machineFields,
    packagings: [],
    shipments: [],
    purchases: [],
    partner_ids: [],
    partner_records: [],
    workcard_ids: [],
    username: null,
    type: 'resources_record',
    jobnumber: jobnumber,
    jobnumber_id: jobnumber.id,
    task_id: null,
    user_id: null,
  }

  return (
    <Popup
      trigger={
        <button type="button" className={buttonClass || 'btn btn-outline-secondary'}>
          {buttonTitle}
        </button>
      }
      position="center center"
      contentStyle={{ width: '100%', maxWidth: '910px', maxHeight: '100%', overflowX: 'hidden', overflowY: 'auto' }}
      closeOnDocumentClick={false}
      modal
    >
      {closeModal => (
        <div className="resources-record-modal modal-popup">
          <a className="close" onClick={closeModal}>
            &times;
          </a>
          <div className="popup-header">{buttonTitle}</div>
          <div className="popup-content">
            <ul className="nav nav-tabs mb-3">
              <li className="nav-item">
                <a className={`nav-link ${currentTab === 'scan' ? 'active' : ''}`} onClick={() => setCurrentTab('scan')} href="#">
                  Scan
                </a>
              </li>
              <li className="nav-item">
                <a className={`nav-link ${currentTab === 'time_form' ? 'active' : ''}`} onClick={() => setCurrentTab('time_form')} href="#">
                  Tidsregistrering
                </a>
              </li>
              <li className="nav-item">
                <a className={`nav-link ${currentTab === 'orders_cases' ? 'active' : ''}`} onClick={() => setCurrentTab('orders_cases')} href="#">
                  Ordrer / Sager
                </a>
              </li>
            </ul>
            {currentTab === 'scan' && (
              <>
                {scanCompeted && <div className="alert alert-success">Scan completed successfully!</div>}
                {!scanCompeted && (
                  <ScanForm
                    form={form}
                    availableAreas={availableAreas}
                    availableMachines={availableMachines}
                    initialValues={scanFormInitialValues}
                    scanCompletedSuccessfully={() => setScanCompeted(true)}
                  />
                )}
              </>
            )}
            {currentTab == 'time_form' && <TimeRegistrationForm record={record} />}
            {currentTab == 'orders_cases' &&
              <SearchFiles defaultTab="files" defaultJobnumber={jobnumber} />
            }
          </div>
        </div>
      )}
    </Popup>
  )
}
